<style lang='scss' scoped>
.userinfo {
    padding: 0 !important;
    cursor: pointer;
    border-radius: 8px;
    margin: 0 4px;
    transition: all 0.3s ease;
    
    &-title {
        height: 100%;
        display: inline-flex;
        align-items: center;
        padding: 0 8px;
    }
    
    &:hover {
        background-color: rgba(0, 212, 255, 0.15);
        box-shadow: 0 0 15px rgba(0, 212, 255, 0.3);
        
        .userinfo-title {
            color: #00d4ff;
        }
        
        ::v-deep .nav-icon {
            filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.8));
            transform: scale(1.1);
        }
        
        .nav-items {
            display: block;
        }
    }
}
.nav-icon {
    font-size: 22px;
    margin-right: 8px;
    transition: all 0.3s ease;
    filter: drop-shadow(0 0 4px rgba(0, 212, 255, 0.5));
}
.nav-items {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    line-height: 36px;
    min-width: 100%;
    white-space: nowrap;
    background: linear-gradient(-45deg, #0a0e27, #1a1f3a, #0d1b2a);
    border: 1px solid rgba(0, 212, 255, 0.3);
    border-radius: 8px;
    box-shadow: 
        0 5px 20px rgba(0, 0, 0, 0.4),
        0 0 15px rgba(0, 212, 255, 0.2);
    overflow: hidden;
    
    a {
        display: block;
        padding: 0 20px;
        color: rgba(255, 255, 255, 0.9);
        transition: all 0.3s ease;
        
        &:hover {
            color: #00d4ff;
            background-color: rgba(0, 212, 255, 0.15);
            text-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
        }
    }
}
</style>


<template>
	<aside class="userinfo" v-show="info">
		<div class="userinfo-title">
			<vIcon type="ios-person" class="nav-icon" :size="22"></vIcon>
			<span>{{info}}&nbsp;</span>
			<vIcon type="arrow-dropdown" :size="16"></vIcon>
		</div>
		<div class="nav-items">
			<a v-for="item in getProjects" :href="item.url" target="_blank">{{item.title}}</a>
            <!-- <a @click="clickshowtab()">{{showCliTab=='true' ? $t('global.common.close', { defaultValue: '关闭' }) : $t('global.common.open', { defaultValue: '打开' }) }}{{$t('global.common.muti_items', { defaultValue: '多标签模式' })}}</a> -->
			<a @click="logout(false)">{{$t('global.common.signout')}}</a>
		</div>
	</aside>
</template>

<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex';
import { LogoutBase } from '../../../service/base';
export default {
	data() {
		return {
            showCliTab:Cookies.get("showtab") || 'false',
		};
    },
	methods: {
        logout:LogoutBase,
        clickshowtab(){
            console.log(this.showCliTab,Cookies.get("showtab"))
            this.bus.$emit("changeshowtab", Cookies.get("showtab") || 'false');
            // this.showCliTab = Cookies.get("showtab");
            if (Cookies.get("showtab") === 'true') {Cookies.set('showtab', 'false', { domain: global.DOMAIN, expires: 7 });this.showCliTab = 'false';}
            else { Cookies.set('showtab', 'true', { domain: global.DOMAIN, expires: 7 });this.showCliTab = 'true';}
        }
	},
	computed: {
		...mapState(['userinfo']),
		// ...mapState('layout', ['sysScopeList']),
		getProjects() {
			const prefix = global.envPrefix;
			return [{
				url: this.handleHostname(`https://${prefix}port.onepinnovate.com/home/panel`),
				title: this.$t('global.common.panel')
			}, {
				url:  this.handleHostname(`https://${prefix}port.onepinnovate.com/home/profile`),
				title: this.$t('global.common.profile', { defaultValue: '我的资料' })
			}, {
				url:  this.handleHostname(`https://${prefix}port.onepinnovate.com/home/password`),
				title: this.$t('global.common.password', { defaultValue: '修改密码' })
			}, {
				url:  this.handleHostname(`https://${prefix}uc-adm.onepinnovate.com/`),
				title: this.$t('global.common.ucadm_title', { defaultValue: '用户管理中心' })
			}, {
				url:  this.handleHostname(`https://${prefix}boss.onepinnovate.com/home`),
				title: this.$t('global.common.erp_title', { defaultValue: 'Boss 子系统' })
			}]
		},
		info() {
            if (this.userinfo.email[0] === '#') return this.userinfo.phone
			return this.userinfo.email
        },
	},
};
</script>
